import jq from "jquery";
import {initAutoLogEvent} from "./event/event";

jq(() => {
    console.log("front init", jq.fn.jquery);

    const $body = jq('body');

    initAutoLogEvent($body);
});